import _extends from '@babel/runtime/helpers/esm/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import React, { useContext } from 'react';
import { get } from 'lodash';
import ChevronSmallDown from '@elliemae/ds-icons/ChevronSmallDown';
import DSButton, { BUTTON_VARIANT } from '@elliemae/ds-button';
import { DropDownContext } from '../context.js';

var DropdownIndicator = function DropdownIndicator(_ref) {
  var innerRef = _ref.innerRef;
      _ref.onKeyDown;
      _ref.options;
      _ref.theme;
      _ref.clearValue;
      _ref.getStyles;
      _ref.getValue;
      _ref.setValue;
      _ref.hasStyle;
      _ref.hasValue;
      _ref.isMulti;
      _ref.isRtl;
      _ref.isDisabled;
      _ref.isFocused;
      _ref.selectOption;
      var selectProps = _ref.selectProps;
      _ref.innerProps;
      _ref.cx;
      var rest = _objectWithoutProperties(_ref, ["innerRef", "onKeyDown", "options", "theme", "clearValue", "getStyles", "getValue", "setValue", "hasStyle", "hasValue", "isMulti", "isRtl", "isDisabled", "isFocused", "selectOption", "selectProps", "innerProps", "cx"]);

  var _useContext = useContext(DropDownContext),
      changeHandleOpening = _useContext.changeHandleOpening,
      changeMenuOpen = _useContext.changeMenuOpen,
      inputInFocus = _useContext.inputInFocus,
      handleOpening = _useContext.handleOpening,
      menuOpen = _useContext.menuOpen,
      onClickDropdownIndicator = _useContext.onClickDropdownIndicator;

  var handleOnClick = function handleOnClick(e) {
    onClickDropdownIndicator(e);
    changeMenuOpen(!menuOpen);
    changeHandleOpening(!handleOpening);
  };

  var handleOnKeyDown = function handleOnKeyDown(e) {
    if (e.key === 'Enter') {
      changeMenuOpen(!menuOpen);
      e.preventDefault();
    }
  };

  return /*#__PURE__*/React.createElement(DSButton, _extends({
    "aria-label": "dropdown-indicator",
    buttonType: "text",
    className: "dropdown-indicator ".concat(get(selectProps, 'menuIsOpen', false) && !inputInFocus ? 'active' : ''),
    icon: /*#__PURE__*/React.createElement(ChevronSmallDown, null),
    innerRef: innerRef,
    onClick: handleOnClick,
    onKeyDown: handleOnKeyDown,
    tabIndex: -1,
    variant: get(selectProps, 'menuIsOpen', false) && !inputInFocus ? BUTTON_VARIANT.ACTIVE : BUTTON_VARIANT.DEFAULT
  }, rest));
};

export default DropdownIndicator;
//# sourceMappingURL=DropdownIndicator.js.map
